import React, { useEffect, useState } from 'react';
import BOLayout from '@/pages/back-office/BOLayout';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import SettingsTopBanner from '@/components/back-office/SettingsTopBanner';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import Drag from '@/assets/media/SVGComponents/Drag';
import BONavigationButton from '@/components/back-office/BONavigationButton';

const RestaurantsList = () => {
    const [restaurants, setRestaurants] = useState([]);
    const navigate = useNavigate();
    const role = JSON.parse(localStorage.getItem('role'));

    useEffect(() => {
        if (role && role !== 'super-admin') {
            toast.info('Zone interdite', {
                position: 'top-center',
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                theme: 'colored',
            });

            navigate('/back-office');

            return;
        }

        const fetchData = async () => {
            try {
                const response = await axios.get(`${import.meta.env.VITE_API_URL}/api/get-restaurants-list`);

                if (response.status === 200) {
                    setRestaurants(response.data);
                }
            } catch (error) {
                console.error('Error fetching Restaurants:', error);
                toast.error('Une erreur est survenue', {
                    position: 'top-center',
                    autoClose: 3500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    theme: 'colored',
                });
            }
        };

        fetchData();
    }, []);

    const handleDropSubmit = async (updatedRestaurants) => {
        const formData = new FormData();
        formData.append('restaurants', JSON.stringify(updatedRestaurants));

        try {
            await axios.put(
                `${import.meta.env.VITE_API_URL}/api/back-office/settings/restaurants/update-priorities`,
                formData
            );

            toast.success('Restaurants modifiés avec succès', {
                position: 'top-center',
                autoClose: 800,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                theme: 'colored',
            });
        } catch (error) {
            console.error('Error editing restaurant:', error);

            toast.error('Une erreur est survenue', {
                position: 'top-center',
                autoClose: 800,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                theme: 'colored',
            });
        }
    };

    const onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }

        const reorderedRestaurants = Array.from(restaurants);
        const [movedRestaurant] = reorderedRestaurants.splice(result.source.index, 1);
        reorderedRestaurants.splice(result.destination.index, 0, movedRestaurant);

        // Assign new priorities based on the new order
        const updatedRestaurants = reorderedRestaurants.map((restaurant, index) => ({
            ...restaurant,
            priority: index + 1,
        }));

        setRestaurants(updatedRestaurants);

        // Log the updated restaurants with their new priorities
        handleDropSubmit(updatedRestaurants);
    };

    return (
        <BOLayout>
            <div className="mb-4 grid grid-cols-1 gap-12">
                <SettingsTopBanner />
                <h1 className="text-3xl font-bold text-center">Liste des restaurants</h1>
                <BONavigationButton
                    text={'Créer un restaurant'}
                    navigationRoute={`/back-office/restaurants/creation`}
                />
            </div>

            <table className="table table-striped table-bordered table-fixed w-full text-center">
                <thead className="border-b border-b-black pb-2 mb-4">
                    <tr>
                        <th className="w-10"></th>
                        <th>Nom</th>
                        <th>Priorité</th>
                    </tr>
                </thead>
                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="steps">
                        {(provided) => (
                            <tbody {...provided.droppableProps} ref={provided.innerRef}>
                                {restaurants.map((restaurant, index) => (
                                    <Draggable key={restaurant.id} draggableId={`${restaurant.id}`} index={index}>
                                        {(provided) => (
                                            <tr
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                className="mb-2"
                                            >
                                                <td>
                                                    <Drag height={10} width={10} />{' '}
                                                </td>
                                                <td>{restaurant.name}</td>
                                                <td>{restaurant.priority}</td>
                                            </tr>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </tbody>
                        )}
                    </Droppable>
                </DragDropContext>
            </table>
        </BOLayout>
    );
};

export default RestaurantsList;
